import axios from 'axios'
import store from '@/store'

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        const code = error.response.status
        if (code == 400)
        {
            try {
                const response = error.response.data
                if (response.message && respone.message == 'Unauthenticated.')
                    store.dispatch('authLogout')
            } catch (e) {}
        }
        return Promise.reject(error)
    }
)



// WEBPACK FOOTER //
// ./src/plugins/interceptors.js